const getCountyTax = (price, tax) => {
  const salesPrice = price ? Number(price) : null;
  const residenceCountyTax = tax ? Number(tax) : null;
  if (salesPrice && residenceCountyTax) {
    if (salesPrice <= 5000) {
      return salesPrice * residenceCountyTax;
    }
    return 5000 * residenceCountyTax;
  }
  return 0;
};

export default getCountyTax;
